import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { push } from 'connected-react-router';

export const removeEntity: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { regionApi },
) =>
  action$.pipe(
    ofType(actions.REMOVE_ENTITY_ACTIONS.REQUESTED),
    switchMap(({ payload: { id, type } }) =>
      regionApi.removeEntity(id, type).pipe(
        switchMap(() =>
          of(actions.removeEntitySucceeded(), push('/countries')),
        ),
        catchError(error => of(actions.removeEntityFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/epics/removeEntity.ts